import axios from 'axios'
import { LEADS_ENDPOINT } from 'cfgCommon/endpoints'

export async function getFilters(query) {
    try {
        const data = await axios.get(`${LEADS_ENDPOINT}/filters${query}`, {
            timeout: 180000, // 3 minutos
        })
        return data.data
    } catch (error) {
        throw new Error(error)
    }
}
